import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Flex } from 'reflexbox'
import T from 'i18n-react'
import { IconButton } from 'react-toolbox/lib/button'
import notifyHoc from 'containers/App/Notification/Notify'

import Revision from 'containers/Project/GreenlightReport/Revision'
import CollapseIconButton from 'components/fulcrum/collapse/CollapseIconButton'

const InfoButton = notifyHoc(IconButton)

const Actions = ({
  toggleCollapse,
  collapse,
  revisions,
  current,
  segment,
  onRevisionChange,
  onAccept,
  onReject,
  approved,
  toggleDialogActive
}) => {

  return (
    <Flex justify='flex-end'>
      <Revision
        source={revisions}
        value={current}
        onChange={onRevisionChange}
        onAccept={onAccept}
        onReject={onReject}
        approved={approved}
      />
      {
          (segment === 'Desktop')
          ? <InfoButton
              message={T.translate('containers.project.greenlightReport.notification.fastTrack')}
              icon='bolt'
              onClick={toggleDialogActive}
            />
          : null
      }
      <CollapseIconButton
        toggleCollapse={toggleCollapse}
        collapse={collapse}
      />
    </Flex>
  )
}

export default Actions
